import React, { useState, useCallback } from 'react';
import './UploadFile.css'
import * as pdfjsLib from 'pdfjs-dist';
import { Navigate, useNavigate } from 'react-router-dom';

pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

const convertSinglePagePdfToImage = async (file) => {
    const fileReader = new FileReader();

    return new Promise((resolve, reject) => {
        fileReader.onload = async function () {
            const typedarray = new Uint8Array(this.result);

            const pdf = await pdfjsLib.getDocument({ data: typedarray }).promise;
            const page = await pdf.getPage(1);
            const viewport = page.getViewport({ scale: 2 });

            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            canvas.width = viewport.width;
            canvas.height = viewport.height;

            await page.render({ canvasContext: context, viewport }).promise;
            const imgData = canvas.toDataURL('image/png');
            resolve(imgData);
        };

        fileReader.onerror = reject;
        fileReader.readAsArrayBuffer(file);
    });
};

const sendImageToWebhook = (base64Image, fileId) => {
    const dataURLtoBlob = (dataURL) => {
        const arr = dataURL.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) u8arr[n] = bstr.charCodeAt(n);
        return new Blob([u8arr], { type: mime });
    };

    const blob = dataURLtoBlob(base64Image);
    const formData = new FormData();
    formData.append('file', blob, 'preview.png'); // ✅ đúng tên field là "file"

    return fetch('https://apihinh.cybertech.com.vn/process_image', {
        method: 'POST',
        body: formData,
    })
        .then(res => res.json())
        .then(json => {
            console.log('✅ Kết quả từ API:', json);

            return {
                fileId: fileId,
                apiResult: json
            };
        })
        .catch(err => {
            console.error('❌ Lỗi khi gọi API:', err);
            return {
                fileId: fileId,
                apiResult: null,
                error: err.message
            };
        });
};


const UploadFile = () => {
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [isDragging, setIsDragging] = useState(false);
    const [uploadStatus, setUploadStatus] = useState('');
    const [previewImage, setPreviewImage] = useState('');
    const [apiResults, setApiResults] = useState([]); // Lưu kết quả API N8N
    const navigate = useNavigate();
    // Form state
    const [formData, setFormData] = useState({
        cccdId: '',
        fullName: '',
        phoneNumber: '',
        companyTaxCode: ''
    });
    const [formErrors, setFormErrors] = useState({});

    const downloadSamplePDF = () => {
        const link = document.createElement('a');
        link.href = '/fixed_check_box.pdf';
        link.download = 'MauDonDongThuanDeXacMinhThongTin.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));

        // Clear error when user starts typing
        if (formErrors[field]) {
            setFormErrors(prev => ({
                ...prev,
                [field]: ''
            }));
        }
    };

    const validateForm = useCallback(() => {
        const errors = {};

        // Only validate CCCD ID as required
        if (!formData.cccdId.trim()) {
            errors.cccdId = 'ID CCCD là bắt buộc';
        } else if (!/^\d{12}$/.test(formData.cccdId.trim())) {
            errors.cccdId = 'ID CCCD phải có 12 chữ số';
        }

        // Optional validation for other fields - only validate if they have values
        if (formData.fullName.trim() && formData.fullName.trim().length < 2) {
            errors.fullName = 'Họ và tên phải có ít nhất 2 ký tự';
        }

        if (formData.phoneNumber.trim() && !/^(0[3|5|7|8|9])+([0-9]{8})$/.test(formData.phoneNumber.trim())) {
            errors.phoneNumber = 'Số điện thoại không hợp lệ';
        }

        if (formData.companyTaxCode.trim() && !/^\d{10}(-\d{3})?$/.test(formData.companyTaxCode.trim())) {
            errors.companyTaxCode = 'Mã số thuế không hợp lệ (10 số hoặc 10-3 số)';
        }

        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    }, [formData]);

    // Simululate upload progress
    const simulateUpload = useCallback((fileId) => {
        const startTime = Date.now();
        const duration = 5000; // 5 giây
        const interval = 100;

        const updater = setInterval(() => {
            const elapsed = Date.now() - startTime;
            const progress = Math.min((elapsed / duration) * 100, 100);

            setUploadedFiles(prev =>
                prev.map(file =>
                    file.id === fileId
                        ? {
                            ...file,
                            uploadProgress: progress,
                            status: progress === 100 ? 'completed' : 'uploading'
                        }
                        : file
                )
            );

            if (progress >= 100) {
                clearInterval(updater);
            }
        }, interval);
    }, []);

    // Handle file processing
    const handleFiles = useCallback((files) => {
        // Validate form first - now only checks CCCD ID
        if (!validateForm()) {
            setUploadStatus('Vui lòng nhập ID CCCD trước khi upload file!');
            setTimeout(() => setUploadStatus(''), 5000);
            return;
        }

        const pdfFiles = files.filter(file => file.type === 'application/pdf');

        if (pdfFiles.length !== files.length) {
            setUploadStatus('Chỉ chấp nhận file PDF!');
            setTimeout(() => setUploadStatus(''), 3000);
            return;
        }

        const newFiles = pdfFiles.map(file => ({
            id: Date.now() + Math.random(),
            file,
            name: file.name,
            size: (file.size / 1024 / 1024).toFixed(2),
            uploadProgress: 0,
            status: 'uploading',
            previewBase64: null
        }));

        setUploadedFiles(prev => [...prev, ...newFiles]);

        // Process each PDF file
        newFiles.forEach(fileObj => {
            convertSinglePagePdfToImage(fileObj.file).then(img => {
                setPreviewImage(img);

                // Save base64 to file object
                setUploadedFiles(prev =>
                    prev.map(f =>
                        f.id === fileObj.id
                            ? { ...f, previewBase64: img }
                            : f
                    )
                );

                // Send to webhook and save result
                sendImageToWebhook(img, formData, fileObj.id).then(result => {
                    if (result) {
                        setApiResults(prev => [...prev, result]);
                    }
                });
            });

            simulateUpload(fileObj.id);
        });
    }, [formData, validateForm, simulateUpload]);

    // Drag handlers
    const handleDrag = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
    }, []);

    const handleDragIn = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    }, []);

    const handleDragOut = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    }, []);

    const handleDrop = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);

        const files = [...e.dataTransfer.files];
        handleFiles(files);
    }, [handleFiles]);

    const handleFileInput = (e) => {
        const files = [...e.target.files];
        handleFiles(files);
    };

    const removeFile = (fileId) => {
        setUploadedFiles(prev => prev.filter(file => file.id !== fileId));
        setApiResults(prev => prev.filter(result => result.fileId !== fileId));
    };

    const handleConfirmAndNext = async () => {
        const allCompleted = uploadedFiles.every(file => file.status === 'completed');

        if (!allCompleted) {
            setUploadStatus('Vui lòng chờ tất cả file upload hoàn thành!');
            setTimeout(() => setUploadStatus(''), 3000);
            return;
        }

        if (!validateForm()) {
            setUploadStatus('Vui lòng kiểm tra lại ID CCCD!');
            setTimeout(() => setUploadStatus(''), 3000);
            return;
        }

        // Check if at least one file is uploaded
        if (uploadedFiles.length === 0) {
            setUploadStatus('Vui lòng upload ít nhất một file PDF!');
            setTimeout(() => setUploadStatus(''), 3000);
            return;
        }

        const finalData = {
            personalInfo: formData,
            uploadedFiles: uploadedFiles.map(file => ({
                name: file.name,
                size: file.size,
                id: file.id
            })),
            apiResults: apiResults.map(result => result.apiResult)
        };

        console.log('✅ Dữ liệu hoàn tất:', finalData);

        // Save to localStorage to pass to next page
        localStorage.setItem('uploadResults', JSON.stringify(finalData));

        alert(`Upload thành công! 
        - ${uploadedFiles.length} file đã upload
        - ${apiResults.length} kết quả API đã nhận
        Sẽ chuyển đến trang tiếp theo...`);

        // Navigate to result page
        window.location.href = '/Result';
    };

    return (
        <div className="pdf-upload-container">
            <div className="upload-card">
                <div className="header">
                    <h1>Upload file consent của end-user</h1>
                    <p>Nhập ID CCCD và upload file consent của end-user</p>
                </div>

                <div className="content">
                    <div className="main-layout">
                        {/* Cột trái - Form thông tin */}
                        <div className="left-column">
                            <div className="form-section">
                                <h3 className="form-title">Thông tin cá nhân</h3>

                                <div className="form-vertical">
                                    <div className="form-field">
                                        <label className="form-label">
                                            ID CCCD <span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            value={formData.cccdId}
                                            onChange={(e) => handleInputChange('cccdId', e.target.value)}
                                            placeholder="Nhập 12 chữ số CCCD"
                                            maxLength="12"
                                            className={`form-input ${formErrors.cccdId ? 'error' : ''}`}
                                        />
                                        {formErrors.cccdId && (
                                            <div className="error-message">{formErrors.cccdId}</div>
                                        )}
                                    </div>

                                    <div className="form-field">
                                        <label className="form-label">
                                            Họ và tên
                                        </label>
                                        <input
                                            type="text"
                                            value={formData.fullName}
                                            onChange={(e) => handleInputChange('fullName', e.target.value)}
                                            placeholder="Nhập họ và tên đầy đủ (tùy chọn)"
                                            className={`form-input ${formErrors.fullName ? 'error' : ''}`}
                                        />
                                        {formErrors.fullName && (
                                            <div className="error-message">{formErrors.fullName}</div>
                                        )}
                                    </div>

                                    <div className="form-field">
                                        <label className="form-label">
                                            Số điện thoại
                                        </label>
                                        <input
                                            type="tel"
                                            value={formData.phoneNumber}
                                            onChange={(e) => handleInputChange('phoneNumber', e.target.value)}
                                            placeholder="Ví dụ: 0123456789 (tùy chọn)"
                                            maxLength="10"
                                            className={`form-input ${formErrors.phoneNumber ? 'error' : ''}`}
                                        />
                                        {formErrors.phoneNumber && (
                                            <div className="error-message">{formErrors.phoneNumber}</div>
                                        )}
                                    </div>

                                    <div className="form-field">
                                        <label className="form-label">
                                            Mã số thuế công ty
                                        </label>
                                        <input
                                            type="text"
                                            value={formData.companyTaxCode}
                                            onChange={(e) => handleInputChange('companyTaxCode', e.target.value)}
                                            placeholder="Ví dụ: 0123456789 hoặc 0123456789-001 (tùy chọn)"
                                            className={`form-input ${formErrors.companyTaxCode ? 'error' : ''}`}
                                        />
                                        {formErrors.companyTaxCode && (
                                            <div className="error-message">{formErrors.companyTaxCode}</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Cột phải - Upload section */}
                        <div className="right-column">
                            <div className="upload-section">
                                <h3 className="form-title">
                                    Upload file consent của end-user <span className="required">*</span>
                                </h3>

                                <button onClick={downloadSamplePDF} className="sample-btn">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                        <polyline points="7,10 12,15 17,10" />
                                        <line x1="12" y1="15" x2="12" y2="3" />
                                    </svg>
                                    Tải xuống file mẫu
                                </button>

                                <div
                                    className={`upload-area ${isDragging ? 'dragging' : ''}`}
                                    onDragEnter={handleDragIn}
                                    onDragLeave={handleDragOut}
                                    onDragOver={handleDrag}
                                    onDrop={handleDrop}
                                >
                                    <input
                                        type="file"
                                        multiple
                                        accept=".pdf"
                                        onChange={handleFileInput}
                                        className="upload-input"
                                    />

                                    <svg className="upload-icon" viewBox="0 0 24 24" fill="none" strokeWidth="2">
                                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                        <polyline points="17,8 12,3 7,8" />
                                        <line x1="12" y1="3" x2="12" y2="15" />
                                    </svg>

                                    <div className="upload-text">
                                        {isDragging ? 'Thả file vào đây' : 'Kéo thả file PDF vào đây'}
                                    </div>
                                    <div className="upload-subtext">hoặc</div>
                                    <button className="choose-btn">Chọn file từ máy tính</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {uploadStatus && (
                        <div className="status-message">
                            <svg className="status-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <circle cx="12" cy="12" r="10" />
                                <line x1="15" y1="9" x2="9" y2="15" />
                                <line x1="9" y1="9" x2="15" y2="15" />
                            </svg>
                            {uploadStatus}
                        </div>
                    )}

                    {uploadedFiles.length > 0 && (
                        <div className="files-list">
                            <h3 className="files-title">Danh sách file đã upload</h3>
                            {uploadedFiles.map(file => (
                                <div key={file.id} className="file-item">
                                    <div className="file-icon">
                                        <svg viewBox="0 0 24 24" fill="none" strokeWidth="2">
                                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                            <polyline points="14,2 14,8 20,8" />
                                            <line x1="16" y1="13" x2="8" y2="13" />
                                            <line x1="16" y1="17" x2="8" y2="17" />
                                            <polyline points="10,9 9,9 8,9" />
                                        </svg>
                                    </div>

                                    <div className="file-info">
                                        <div className="file-name">{file.name}</div>
                                        <div className="file-size">{file.size} MB</div>
                                    </div>

                                    <div className="file-progress">
                                        <div className="progress-bar">
                                            <div
                                                className="progress-fill"
                                                style={{ width: `${file.uploadProgress}%` }}
                                            ></div>
                                        </div>
                                        <div className={`progress-text ${file.status === 'completed' ? 'status-success' : 'status-uploading'}`}>
                                            {file.status === 'completed' ? 'Hoàn thành' : `${Math.round(file.uploadProgress)}%`}
                                        </div>
                                    </div>

                                    <button
                                        onClick={() => removeFile(file.id)}
                                        className="remove-btn"
                                    >
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <line x1="18" y1="6" x2="6" y2="18" />
                                            <line x1="6" y1="6" x2="18" y2="18" />
                                        </svg>
                                    </button>
                                </div>
                            ))}
                            {/* Button xác nhận */}

                        </div>
                    )}
                    <div className="confirm-section">
                        <button
                            onClick={handleConfirmAndNext}
                            className="confirm-btn"
                            disabled={!uploadedFiles.every(file => file.status === 'completed') || uploadedFiles.length === 0}
                        >
                            Xác nhận và tiếp tục
                        </button>
                    </div>
                </div>
            </div>
        </div >
    );
};
export default UploadFile